// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__-cf9s","spin":"Spinner_spin__AmuAp","thin":"Spinner_thin__6IBfg"};